import FixedApp from './apps/FixedApp'
import PrivateApp from './apps/PrivateApp'

// The window.scaConfig?.buttonConfig is feature toggleable
const appConfig = window.scaConfig?.appConfig ?? 'private'

export default function AppMapper() {
  if (appConfig === 'corporateFixed' || appConfig === 'privateFixed')
    return <FixedApp variant={appConfig} />
  return <PrivateApp />
}
